export default "__VITE_ASSET__DTHTDCir__"